/**
 * @flow
 */
import { Box, Typography } from '@mui/material';
import QuestionSummary from 'components/@home/drawers/FormAnalyticsDrawer/QuestionSummary';
import TabPanel from 'components/@home/drawers/FormAnalyticsDrawer/TabPanel';
import React from 'react';
import { I18n } from 'utils/i18n';

type Props = {
  form: Object,
  summary: Object,
  tab: number,
  index: number,
  setQuestion: Function,
  setAnswer: Function,
  setTab: Function,
};

const TabSummary = ({ form, summary, tab, index, setQuestion, setAnswer, setTab }: Props) => {
  const pct = summary.totals.totalUsers
    ? (100 * summary.totals.uniqueAnswers) / summary.totals.totalUsers
    : 0;
  const showAnswers = (question, answer = 'All') => {
    setTab(index + 1);
    setQuestion(question);
    setAnswer(answer);
  };
  return (
    <TabPanel value={tab} index={index} sx={{ overflowY: 'scroll' }}>
      <Typography sx={{ mt: '20px', fontSize: 18, fontWeight: 'bold' }}>
        {pct.toFixed()}%
      </Typography>
      <Typography>{I18n.t('FormAnalyticsDrawer.Completion rate')}</Typography>
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', mt: '20px' }}>
        {summary &&
          form.questions?.map((question, idx) => (
            <QuestionSummary
              key={question._id}
              index={idx}
              question={question}
              summary={summary[question._id]}
              showAnswers={showAnswers}
            />
          ))}
      </Box>
    </TabPanel>
  );
};
export default TabSummary;
